export default "__VITE_ASSET__CU7ujltw__"